function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7188 29.8125C24.7086 29.8125 30.375 24.1461 30.375 17.1562C30.375 10.1664 24.7086 4.5 17.7188 4.5C10.7289 4.5 5.0625 10.1664 5.0625 17.1562C5.0625 24.1461 10.7289 29.8125 17.7188 29.8125Z",
  fill: "url(#paint0_linear_224_9244)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 7.875L19.4062 15.4688L27 16.875L19.4062 18.2812L18 25.875L16.5938 18.2812L9 16.875L16.5938 15.4688L18 7.875Z",
  fill: "url(#paint1_linear_224_9244)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M25.875 5.0625L26.4375 7.875L29.25 8.4375L26.4375 9L25.875 11.8125L25.3125 9L22.5 8.4375L25.3125 7.875L25.875 5.0625Z",
  fill: "url(#paint2_linear_224_9244)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M7.875 22.5L8.325 24.3L10.125 24.75L8.325 25.2L7.875 27L7.425 25.2L5.625 24.75L7.425 24.3L7.875 22.5Z",
  fill: "url(#paint3_linear_224_9244)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_224_9244",
  x1: 2.14183,
  y1: 1.57933,
  x2: 33.2957,
  y2: 32.7332,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE9FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DBEAFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_224_9244",
  x1: 0,
  y1: 0,
  x2: 36,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7C3AED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2563EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_224_9244",
  x1: 0,
  y1: -1.6875,
  x2: 36,
  y2: 34.3125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7C3AED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2563EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_224_9244",
  x1: 0,
  y1: -1.125,
  x2: 36,
  y2: 34.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7C3AED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2563EB"
})));

function SvgIconAiReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiReport);
export default __webpack_public_path__ + "static/media/icon_ai_report.8205513b.svg";
export { ForwardRef as ReactComponent };